import { SiteLicense } from "../types/api.types";
import type { SiteCategoriesResponse } from "./backend-types";

/** Whether the site with the given id has a premium license. `false` while categories load, without an id, or if no site matches. */
export function isPremiumSite(
  siteCategories: ReadonlyArray<SiteCategoriesResponse> | undefined,
  siteId: number | undefined
): boolean {
  return (
    siteCategories?.find((site) => site.id === siteId)?.license ===
    SiteLicense.premium
  );
}
